import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import './HistoryDrawer.scss';
import HistoryTab from '../../components/HistoryTab/HistoryTab';
import HelpComponent from '../../components/HelpComponent/HelpComponent';

function HistoryDrawer(props) {
    const { open, toggleDrawerClose, value} = props;
    return (
        <Drawer
        anchor='right'
        open={open}
        onClose={toggleDrawerClose}
        className='drawer-history-tab-mobile'
      >
        <Box
      sx={{ width: 250, paddingTop:'10px',paddingLeft:'10px' }}
      role="presentation"
    >
        { value === 'history' && <HistoryTab toggleDrawerClose={toggleDrawerClose}/>}
        { value === 'help' && <HelpComponent />}
        </Box>
      </Drawer>
    )
}

export default HistoryDrawer
